import React, { memo, useState } from "react";
import { Handle, Position } from "reactflow";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const CustomNode = ({ id, data, setNodes }) => {
  const {
    label = "Untitled Node",
    onDelete,
    color = "#ffffff",
    fontColor = "#000000",
    fontSize = "12px",
    fontStyle = "normal",
    description = "description",
  } = data || {};

  const [openConfirm, setOpenConfirm] = useState(false);

  return (
    <>
      <div
        style={{
          position: "relative",
          padding: "12px 16px",
          width: "180px",
          background: color,
          border: "1px solid #CFD4E9",
          borderRadius: "6px",
          color: fontColor,
          fontSize,
          fontStyle,
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          wordWrap: "break-word",
          whiteSpace: "normal",
          overflowWrap: "break-word",
          textAlign: "left",
        }}
      >
        {/* DELETE ICON GROUP */}
        <div
          style={{
            position: "absolute",
            top: "-12px",
            right: "-12px",
            display: "flex",
            gap: "2px",
            backgroundColor: "#6C7A99",
            borderRadius: "12px",
            padding: "2px 6px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
            cursor: "pointer",
            zIndex: 10,
          }}
        >
          <DeleteIcon
            style={{
              fontSize: "18px",
              color: "white",
              userSelect: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setOpenConfirm(true);
            }}
            title="Delete Node"
          />
        </div>

        {/* NODE LABEL */}
        <div
          style={{
            fontWeight: 500,
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflowWrap: "break-word",
          }}
          title={description}
        >
          {label}
        </div>

        {/* TARGET HANDLE */}
        <Handle
          type="target"
          position={Position.Left}
          style={{ background: "#555" }}
        />

        {/* SOURCE HANDLE */}
        <Handle
          type="source"
          position={Position.Right}
          style={{ background: "#555" }}
        />
      </div>

      {/* CONFIRMATION DIALOG */}
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
      >
        <DialogTitle>Delete Node</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete "{label}"?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>
            Cancel
          </Button>

          <Button
            color="error"
            variant="contained"
            onClick={() => {
              setOpenConfirm(false);
              if (typeof onDelete === "function") {
                onDelete(id);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default memo(CustomNode);